export default __webpack_public_path__ + "static/media/os_centos.56e61ea3.svg";